import React, { ComponentType, memo, SVGProps } from "react";
import { useTranslation } from "react-i18next";
import ActivityLayout from "app/components/Layouts/ActivityPageLayout";
import IncomingInvitations from "./IncomingInvitations";
import OutgoingInvitations from "./OutgoingInvitations";
import { ActivityInvitationsModel } from "./indexModel";
import { cls } from "app/utils";
import styles from "./styles.module.scss";

type notification = "incoming" | "outgoing";

const DownArrow = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M4.1665 11.845C4.1665 12.0624 4.25362 12.28 4.42492 12.4456L9.38105 17.2509C9.72366 17.583 10.2784 17.583 10.6201 17.2509L15.5762 12.4456C15.9188 12.1135 15.9188 11.5757 15.5762 11.2443L15.5009 11.1713C15.1583 10.8391 14.6036 10.8391 14.2619 11.1713L10.8768 14.4533L10.8768 3.34954C10.8768 2.8806 10.4842 2.5 10.0006 2.5C9.51689 2.5 9.12435 2.8806 9.12435 3.34954L9.12435 14.4533L5.73925 11.1713C5.39665 10.8391 4.84195 10.8391 4.50022 11.1713L4.42492 11.2443C4.25362 11.4104 4.1665 11.6276 4.1665 11.845Z"
      fill="currentColor"
    />
  </svg>
);

const UpArrow = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M4.1665 8.155C4.1665 7.9376 4.25362 7.72 4.42492 7.5544L9.38105 2.7491C9.72366 2.417 10.2784 2.417 10.6201 2.7491L15.5762 7.5544C15.9188 7.8865 15.9188 8.4243 15.5762 8.7557L15.5009 8.8287C15.1583 9.1609 14.6036 9.1609 14.2619 8.8287L10.8768 5.5467L10.8768 16.6505C10.8768 17.1194 10.4842 17.5 10.0006 17.5C9.51689 17.5 9.12435 17.1194 9.12435 16.6505L9.12435 5.5467L5.73925 8.8287C5.39665 9.1609 4.84195 9.1609 4.50022 8.8287L4.42492 8.7557C4.25362 8.5896 4.1665 8.3724 4.1665 8.155Z"
      fill="currentColor"
    />
  </svg>
);

const tabs: { key: notification; label: "Incoming" | "Outgoing"; Icon: any }[] =
  [
    { key: "incoming", label: "Incoming", Icon: DownArrow },
    { key: "outgoing", label: "Outgoing", Icon: UpArrow },
  ];

const ActivityInvitations = () => {
  const { t } = useTranslation();
  const { activeTab, handleTabChange, invitations, outgoingCount } =
    ActivityInvitationsModel();

  const tabLabelGenerator = (
    key: notification,
    label: "Incoming" | "Outgoing",
    Icon: ComponentType<SVGProps<SVGSVGElement>>,
    isActive: boolean,
  ) => {
    if (key === "outgoing") {
      return (
        <div className={styles.counter_container}>
          <Icon
            className={cls(styles.arrow, {
              [styles.active_icon]: isActive,
            })}
          />
          {t(label)}
          {outgoingCount > 0 ? (
            <p
              className={cls(styles.counter, {
                [styles.counter_active]: isActive,
                [styles.counter_square]: outgoingCount > 9,
              })}
            >
              {outgoingCount}
            </p>
          ) : null}
        </div>
      );
    }

    return (
      <div className={styles.counter_container}>
        <Icon
          className={cls(styles.arrow, {
            [styles.active_icon]: isActive,
          })}
        />
        {t(label)}
        {invitations > 0 && (
          <p
            className={cls(styles.counter, {
              [styles.counter_active]: isActive,
            })}
          >
            {invitations}
          </p>
        )}
      </div>
    );
  };

  return (
    <ActivityLayout>
      <div className={styles.tabs_container}>
        {tabs.map(({ key, label, Icon }) => {
          const isActive = activeTab === key;

          return (
            <div
              key={key}
              className={cls(styles.tab_btn, {
                [styles.tab_btn_active]: isActive,
              })}
              onClick={() => handleTabChange(key)}
            >
              {tabLabelGenerator(key, label, Icon, isActive)}
            </div>
          );
        })}
      </div>

      {activeTab === "incoming" && <IncomingInvitations />}
      {activeTab === "outgoing" && <OutgoingInvitations />}
    </ActivityLayout>
  );
};

export default memo(ActivityInvitations);
